export default __webpack_public_path__ + "static/media/Intro Joyce.c1e632dd.mp3";